module.exports = __webpack_public_path__ + "static/media/caex_half_fuel.8fd692bf.svg";